import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeHtml',
  standalone: true // Quita esto si usas NgModules tradicionales
})
export class SanitizeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | undefined): SafeHtml {
    if (!value) return '';

    const cleanHtml = value.replace(/\s*style=(['"])(.*?)\1/gi, '');

    return this.sanitizer.bypassSecurityTrustHtml(cleanHtml);
  }
}